import { motion } from 'framer-motion';
import React from 'react';
import { Link } from 'react-router-dom';

const Banner = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.5, type: 'spring', stiffness: 300 }}
      className='banner'>
      <p>
        🚀 Register Now And Enjoy Your{' '}
        <span style={{ fontWeight: 'bold' }}>Free Trial Period</span> With Full
        Access to All Features!{' '}
        <Link to={'/externalBusinessRequest'} className='banner-link'>
          Join us now
        </Link>
      </p>
    </motion.div>
  );
};

export default Banner;
